import React from "react";
import ReactDOM from "react-dom";
import "./assets/css/App.css";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import AuthLayout from "./layouts/auth";
import AdminLayout from "./layouts/admin";
import RTLLayout from "./layouts/rtl";
import { ChakraProvider } from "@chakra-ui/react";
import theme from "./theme/theme";
import { QueryClient, QueryClientProvider } from "react-query";

// ✅ Crie o client fora do componente
const queryClient = new QueryClient();

type ComponentType = React.ComponentType<any>;

const PrivateRoute: React.FC<{
  component: ComponentType;
  [key: string]: any;
}> = ({ component: Component, ...rest }) => {
  const Token = localStorage.getItem("AcessToken");
  const isAuthenticated = Token !== null;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/auth/login" />
        )
      }
    />
  );
};

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme}>
        <HashRouter>
          <Switch>
            <Route path="/auth" component={AuthLayout} />
            <PrivateRoute path="/admin" component={AdminLayout} />
            <PrivateRoute path="/rtl" component={RTLLayout} />
            <Redirect from="/" to="/auth" />
          </Switch>
        </HashRouter>
      </ChakraProvider>
    </QueryClientProvider>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
